var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"@xlearn-player@0.15.129+6297d97.linux"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["minerva@neting"]={id:"@xlearn-player@0.15.129+6297d97.linux"};
      